'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('../components');

var _reduxRouter = require('redux-router');

var _utils = require('helpers/utils');

var _audiences = require('redux/modules/audiences');

var _organizations = require('redux/modules/organizations');

var _regions = require('redux/modules/regions');

var _tags = require('redux/modules/tags');

var _types = require('redux/modules/types');

var _venues = require('redux/modules/venues');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FiltersContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    audiences: state.audiences.menu,
    location: state.router.location,
    organizations: state.organizations.menu,
    regions: state.regions.menu,
    selectedAudiences: state.audiences.selected,
    selectedOrganizations: state.organizations.selected,
    selectedRegions: state.regions.selected,
    selectedTags: state.tags.selected,
    selectedTypes: state.types.selected,
    selectedVenues: state.venues.selected,
    tags: state.tags.menu,
    types: state.types.menu,
    venues: state.venues.menu
  };
}, {
  push: _reduxRouter.push,
  setSelectedAudiences: _audiences.setSelected,
  setSelectedOrganizations: _organizations.setSelected,
  setSelectedRegions: _regions.setSelected,
  setSelectedTags: _tags.setSelected,
  setSelectedTypes: _types.setSelected,
  setSelectedVenues: _venues.setSelected
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FiltersContainer, _Component);

  function FiltersContainer() {
    (0, _classCallCheck3.default)(this, FiltersContainer);
    return (0, _possibleConstructorReturn3.default)(this, (FiltersContainer.__proto__ || (0, _getPrototypeOf2.default)(FiltersContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(FiltersContainer, [{
    key: 'filtersAction',
    value: function filtersAction(item) {
      var push = this.props.push; // eslint-disable-line no-shadow

      var selected = {
        audiences: this.props.selectedAudiences,
        organizations: this.props.selectedOrganizations,
        regions: this.props.selectedRegions,
        types: this.props.selectedTypes,
        tags: this.props.selectedTags,
        venues: this.props.selectedVenues
      };
      var select = {
        audiences: this.props.setSelectedAudiences,
        organizations: this.props.setSelectedOrganizations,
        regions: this.props.setSelectedRegions,
        types: this.props.setSelectedTypes,
        tags: this.props.setSelectedTags,
        venues: this.props.setSelectedVenues
      };

      var newQuery = (0, _utils.updateSelections)(item, selected, select);

      push({ pathname: '/evenements', query: newQuery });
    }
  }, {
    key: 'filtersClear',
    value: function filtersClear(types) {
      var _props = this.props,
          location = _props.location,
          push = _props.push; // eslint-disable-line no-shadow

      var queryParams = location.query;

      var select = {
        audiences: this.props.setSelectedAudiences,
        organizations: this.props.setSelectedOrganizations,
        regions: this.props.setSelectedRegions,
        types: this.props.setSelectedTypes,
        tags: this.props.setSelectedTags,
        venues: this.props.setSelectedVenues
      };
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(types), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var type = _step.value;

          select[type]([]);
          delete queryParams[type];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      push({ pathname: '/evenements', query: queryParams });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_components.Filters, (0, _extends3.default)({ action: this.filtersAction.bind(this), clear: this.filtersClear.bind(this) }, this.props));
    }
  }]);
  return FiltersContainer;
}(_react.Component), _class2.propTypes = {
  audiences: _react.PropTypes.array.isRequired,
  location: _react.PropTypes.object,
  organizations: _react.PropTypes.array.isRequired,
  push: _react.PropTypes.func,
  queryParams: _react.PropTypes.object,
  regions: _react.PropTypes.array.isRequired,
  selectedOrganizations: _react.PropTypes.array.isRequired,
  selectedAudiences: _react.PropTypes.array.isRequired,
  selectedRegions: _react.PropTypes.array.isRequired,
  selectedTags: _react.PropTypes.array.isRequired,
  selectedTypes: _react.PropTypes.array.isRequired,
  selectedVenues: _react.PropTypes.array.isRequired,
  setSelectedAudiences: _react.PropTypes.func.isRequired,
  setSelectedOrganizations: _react.PropTypes.func.isRequired,
  setSelectedRegions: _react.PropTypes.func.isRequired,
  setSelectedTags: _react.PropTypes.func.isRequired,
  setSelectedTypes: _react.PropTypes.func.isRequired,
  setSelectedVenues: _react.PropTypes.func.isRequired,
  tags: _react.PropTypes.array.isRequired,
  types: _react.PropTypes.array.isRequired,
  venues: _react.PropTypes.array.isRequired
}, _temp)) || _class);
exports.default = FiltersContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FiltersContainer.js
// module id = 1156
// module chunks = 0